export default __webpack_public_path__ + "static/media/user.ecde53a5.jpg";